import { FC } from 'react';
import './ShadowCircle.scss';
import { classNames } from '@tools/Utils/React';

const ShadowCircle: FC<{ gradient?: boolean; className?: string }> = ({ gradient = false, className }) => {
	return <div className={classNames(`shadow-circle ${className}`, { gradient: gradient })} />;
};

export default ShadowCircle;
